!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define("react-tilty", ["React"], t) : "object" == typeof exports ? exports["react-tilty"] = t(require("react")) : e["react-tilty"] = t(e.React);
}(self, function (e) {
  return function () {
    "use strict";

    var t = {
      352: function _(e, t, n) {
        n.r(t), n.d(t, {
          default: function _default() {
            return l;
          }
        });
        var r = n(798),
            o = n.n(r);

        function i(e, t) {
          var n = Object.keys(e);

          if (Object.getOwnPropertySymbols) {
            var r = Object.getOwnPropertySymbols(e);
            t && (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), n.push.apply(n, r);
          }

          return n;
        }

        function c(e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? i(Object(n), !0).forEach(function (t) {
              u(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }

          return e;
        }

        function u(e, t, n) {
          return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e;
        }

        function a(e, t) {
          return function (e) {
            if (Array.isArray(e)) return e;
          }(e) || function (e, t) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
              var n = [],
                  r = !0,
                  o = !1,
                  i = void 0;

              try {
                for (var c, u = e[Symbol.iterator](); !(r = (c = u.next()).done) && (n.push(c.value), !t || n.length !== t); r = !0) {
                  ;
                }
              } catch (e) {
                o = !0, i = e;
              } finally {
                try {
                  r || null == u.return || u.return();
                } finally {
                  if (o) throw i;
                }
              }

              return n;
            }
          }(e, t) || function (e, t) {
            if (e) {
              if ("string" == typeof e) return f(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e, t) : void 0;
            }
          }(e, t) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }

        function f(e, t) {
          (null == t || t > e.length) && (t = e.length);

          for (var n = 0, r = new Array(t); n < t; n++) {
            r[n] = e[n];
          }

          return r;
        }

        var l = function l(e) {
          var t = e.style,
              n = void 0 === t ? {} : t,
              i = e.className,
              u = void 0 === i ? "" : i,
              f = e.reverse,
              l = void 0 !== f && f,
              s = e.max,
              d = void 0 === s ? 35 : s,
              p = e.perspective,
              v = void 0 === p ? 1e3 : p,
              y = e.easing,
              m = void 0 === y ? "cubic-bezier(.03,.98,.52,.99)" : y,
              g = e.scale,
              b = void 0 === g ? 1 : g,
              w = e.speed,
              h = void 0 === w ? 300 : w,
              O = e.axis,
              j = void 0 === O ? "" : O,
              x = e.reset,
              E = void 0 === x || x,
              M = e.glare,
              A = void 0 !== M && M,
              S = e.maxGlare,
              P = void 0 === S ? 1 : S,
              R = e.glareStyle,
              Y = void 0 === R ? {} : R,
              L = e.gyroscope,
              X = void 0 === L || L,
              F = e.gyroscopeMinAngleX,
              C = void 0 === F ? -45 : F,
              T = e.gyroscopeMaxAngleX,
              q = void 0 === T ? 45 : T,
              W = e.gyroscopeMinAngleY,
              k = void 0 === W ? -45 : W,
              D = e.gyroscopeMaxAngleY,
              I = void 0 === D ? 45 : D,
              N = e.onMouseEnter,
              _ = void 0 === N ? function () {} : N,
              z = e.onMouseMove,
              B = void 0 === z ? function () {} : z,
              G = e.onMouseLeave,
              H = void 0 === G ? function () {} : G,
              U = e.children,
              $ = a((0, r.useState)({
            position: "relative",
            willChange: "transform"
          }), 2),
              J = $[0],
              K = $[1],
              Q = a((0, r.useState)({
            position: "absolute",
            top: "50%",
            left: "50%",
            pointerEvents: "none",
            backgroundImage: "linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
            transform: "rotate(180deg) translate(-50%, -50%)",
            transformOrigin: "0% 0%",
            opacity: "0"
          }), 2),
              V = Q[0],
              Z = Q[1],
              ee = (0, r.useRef)(0),
              te = (0, r.useRef)(0),
              ne = (0, r.useRef)(0),
              re = (0, r.useRef)(0),
              oe = (0, r.useRef)(null),
              ie = (0, r.useRef)(null),
              ce = l ? 1 : -1,
              ue = (0, r.useRef)(null);

          (0, r.useEffect)(function () {
            return function () {
              clearTimeout(oe.current), "undefined" != typeof window && window.cancelAnimationFrame(ie.current);
            };
          }, []), (0, r.useEffect)(function () {
            if (!A || "undefined" == typeof window) return function () {};

            var e = function e() {
              Z(function (e) {
                return c(c({}, e), {}, {
                  width: 2 * ue.current.offsetWidth,
                  height: 2 * ue.current.offsetWidth
                });
              });
            };

            return window.addEventListener("resize", e), function () {
              window.removeEventListener("resize", e);
            };
          }, [A]), (0, r.useLayoutEffect)(function () {
            Z(function (e) {
              return c(c({}, e), {}, {
                width: 2 * ue.current.offsetWidth,
                height: 2 * ue.current.offsetWidth
              });
            });
          }, []);

          var ae = function ae() {
            var e = ue.current.getBoundingClientRect();
            ee.current = ue.current.offsetWidth, te.current = ue.current.offsetHeight, ne.current = e.left, re.current = e.top;
          },
              fe = (0, r.useCallback)(function (e) {
            var t = (e.nativeEvent.clientX - ne.current) / ee.current,
                n = (e.nativeEvent.clientY - re.current) / te.current;
            return t = Math.min(Math.max(t, 0), 1), n = Math.min(Math.max(n, 0), 1), {
              tiltX: (ce * (d / 2 - t * d)).toFixed(2),
              tiltY: (ce * (n * d - d / 2)).toFixed(2),
              percentageX: 100 * t,
              percentageY: 100 * n
            };
          }, [d, ce]),
              le = (0, r.useCallback)(function (e) {
            var t = fe(e);
            K(function (e) {
              return c(c({}, e), {}, {
                transform: "perspective(".concat(v, "px) rotateX(").concat("x" === j.toLowerCase() ? 0 : t.tiltY, "deg) rotateY(").concat("y" === j.toLowerCase() ? 0 : t.tiltX, "deg) scale3d(").concat(b, ", ").concat(b, ", ").concat(b, ")")
              });
            }), A && Z(function (e) {
              return c(c({}, e), {}, {
                transform: "rotate(".concat(t.angle, "deg) translate(-50%, -50%)"),
                opacity: t.percentageY * P / 100
              });
            }), ie.current = null;
          }, [j, fe, A, P, v, b]),
              se = function se() {
            clearTimeout(oe.current), K(function (e) {
              return c(c({}, e), {}, {
                transition: "".concat(h, "ms ").concat(m)
              });
            }), oe.current = setTimeout(function () {
              K(function (e) {
                return c(c({}, e), {}, {
                  transition: ""
                });
              });
            }, h);
          };

          return (0, r.useEffect)(function () {
            if (!X) return function () {};

            var e = function e(_e) {
              if (null !== _e.gamma && null !== _e.beta && "undefined" != typeof window) {
                ae();
                var t = I - k,
                    n = (q - C) / ee.current,
                    r = t / te.current,
                    o = (_e.gamma - C) / n,
                    i = (_e.beta - k) / r;
                null !== ie.current && "undefined" != typeof window && window.cancelAnimationFrame(ie.current), _e.nativeEvent = {
                  clientX: o + ne.current,
                  clientY: i + re.current
                }, ie.current = requestAnimationFrame(function () {
                  return le(_e);
                });
              }
            };

            return window.addEventListener("deviceorientation", e), function () {
              window.removeEventListener("deviceorientation", e);
            };
          }, [X, q, I, C, k, le]), o().createElement("div", {
            ref: ue,
            style: c(c({}, n), J),
            className: u,
            onMouseEnter: function onMouseEnter(e) {
              return ae(), se(), _(e);
            },
            onMouseMove: function onMouseMove(e) {
              return e.persist(), null !== ie.current && "undefined" != typeof window && window.cancelAnimationFrame(ie.current), ie.current = requestAnimationFrame(function () {
                return le(e);
              }), B(e);
            },
            onMouseLeave: function onMouseLeave(e) {
              return se(), E && "undefined" != typeof window && window.requestAnimationFrame(function () {
                K(function (e) {
                  return c(c({}, e), {}, {
                    transform: "perspective(".concat(v, "px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)")
                  });
                }), A && Z(function (e) {
                  return c(c({}, e), {}, {
                    transform: "rotate(180deg) translate(-50%, -50%)",
                    opacity: 0
                  });
                });
              }), H(e);
            }
          }, A && o().createElement("div", {
            className: "tilty-glare-wrapper",
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              overflow: "hidden"
            }
          }, o().createElement("div", {
            className: "tilty-glare",
            style: c(c({}, Y), V)
          })), U);
        };
      },
      798: function _(t) {
        t.exports = e;
      }
    },
        n = {};

    function r(e) {
      if (n[e]) return n[e].exports;
      var o = n[e] = {
        exports: {}
      };
      return t[e](o, o.exports, r), o.exports;
    }

    return r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, {
        a: t
      }), t;
    }, r.d = function (e, t) {
      for (var n in t) {
        r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
          enumerable: !0,
          get: t[n]
        });
      }
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r(352);
  }();
});